export function formatString(preformattedString?: string, ...args: (string | number)[]): string {
    if (typeof preformattedString !== "string") {
        return "";
    }

    return preformattedString.replace(
        /{(\d+)}/g,
        (match, i: number): string => `${typeof args[i] !== "undefined" ? args[i] : match}`,
    );
}

export function removeNonDigitCharacters(value: string): string {
    return value.replace(new RegExp(/\D+/, 'g'), '')
}
